var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "78.702%",
    id: "social-group_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C6C9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "silver",
    fill: "url(#social-group_svg__a)",
    cx: 24,
    cy: 24,
    r: 23.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.929 19.154C19.929 16.8 21.693 15 24 15c2.307 0 4.071 1.8 4.071 4.154S26.307 23.308 24 23.308c-2.307 0-4.071-1.8-4.071-4.154zM24 26.077c-6.243 0-8.143 4.57-8.143 4.57V33h16.286v-2.354s-1.9-4.57-8.143-4.57z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.714 15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.045,
    cy: 3.419,
    rx: 3.348,
    ry: 3.419
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.045 9.574c-1.607 0-2.813.41-3.75 1.095 3.08 1.504 4.285 4.103 4.285 4.377v.136h5.491v-1.778c0-.137-1.473-3.83-6.026-3.83z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.221,
    cy: 3.419,
    rx: 3.456,
    ry: 3.419
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.221 9.574c1.66 0 2.903.41 3.871 1.095-3.18 1.504-4.424 4.103-4.424 4.377v.136H0v-1.778c0-.137 1.52-3.83 6.221-3.83z"
  }))))));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='48px' height='48px' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cdefs%3E %3ClinearGradient x1='50%25' y1='0%25' x2='50%25' y2='78.7020597%25' id='linearGradient-1'%3E %3Cstop stop-color='%23D8D8D8' offset='0%25'%3E%3C/stop%3E %3Cstop stop-color='%23C7C6C9' offset='100%25'%3E%3C/stop%3E %3C/linearGradient%3E %3C/defs%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-242.000000, -51.000000)'%3E %3Cg transform='translate(242.000000, 51.000000)'%3E %3Ccircle stroke='%23C0C0C0' fill='url(%23linearGradient-1)' cx='24' cy='24' r='23.5'%3E%3C/circle%3E %3Cg transform='translate(9.000000, 15.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E %3Cpath d='M10.9285714,4.15384615 C10.9285714,1.8 12.6928571,0 15,0 C17.3071429,0 19.0714286,1.8 19.0714286,4.15384615 C19.0714286,6.50769231 17.3071429,8.30769231 15,8.30769231 C12.6928571,8.30769231 10.9285714,6.50769231 10.9285714,4.15384615 Z M15,11.0769231 C8.75714286,11.0769231 6.85714286,15.6461538 6.85714286,15.6461538 L6.85714286,18 L23.1428571,18 L23.1428571,15.6461538 C23.1428571,15.6461538 21.2428571,11.0769231 15,11.0769231 Z'%3E%3C/path%3E %3Cg transform='translate(19.714286, 0.000000)'%3E %3Cellipse cx='4.04464286' cy='3.41945289' rx='3.34821429' ry='3.41945289'%3E%3C/ellipse%3E %3Cpath d='M4.04464286,9.57446809 C2.4375,9.57446809 1.23214286,9.98480243 0.294642857,10.668693 C3.375,12.1732523 4.58035714,14.7720365 4.58035714,15.0455927 L4.58035714,15.1823708 L10.0714286,15.1823708 L10.0714286,13.4042553 C10.0714286,13.2674772 8.59821429,9.57446809 4.04464286,9.57446809 Z'%3E%3C/path%3E %3C/g%3E %3Cg%3E %3Cellipse cx='6.22119816' cy='3.41945289' rx='3.4562212' ry='3.41945289'%3E%3C/ellipse%3E %3Cpath d='M6.22119816,9.57446809 C7.88018433,9.57446809 9.12442396,9.98480243 10.0921659,10.668693 C6.9124424,12.1732523 5.66820276,14.7720365 5.66820276,15.0455927 L5.66820276,15.1823708 L0,15.1823708 L0,13.4042553 C0,13.2674772 1.52073733,9.57446809 6.22119816,9.57446809 Z'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgSocialGroup as ReactComponent };